import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/loading";

interface RouteGuardProps {
  isPrivate?: boolean;
  isAuth?: boolean;
}

const RouteGuard = ({
  isPrivate = false,
  isAuth = false,
}: RouteGuardProps) => {

  const { user, isAuthenticated, isLoading } = useAuth();

  // =============================
  // LOADING
  // =============================

  if (isLoading) {
    return <Loading />;
  }

  // =============================
  // SECURITY CHECK (important)
  // =============================

  if (user?.security) {
    if (!user.security.is_active || user.security.is_suspended) {
      return <Navigate to="/account-disabled" replace />;
    }
  }

  // =============================
  // PRIVATE ROUTES
  // =============================

  if (isPrivate && !isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // =============================
  // AUTH ROUTES (login, register)
  // =============================

  if (isAuth && isAuthenticated) {

    // 👉 Redirection intelligente
    const isAdmin = user?.roles?.some(r => r.name === "admin");

    if (isAdmin) {
      return <Navigate to="/admin/dashboard/home" replace />;
    }

    return <Navigate to="/" replace />;
  }

  // =============================
  // ACCESS OK
  // =============================

  return <Outlet />;
};

export default RouteGuard;